import { login2 } from '@/api/login/user'
import { getToken, setToken, removeToken } from '@/utils/auth'

const state = {
  token: getToken(),
  refreshToken:'',
  acount:''
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_REFRESH_TOKEN: (state, token) => {
    state.refreshToken = token
  },
}

const actions = {
  // user login
  login({ commit }, userInfo) {
    const { account, password } = userInfo
    return new Promise((resolve, reject) => {
      login2({ account: account, password: password }).then(response => {
        const { data } = response
        commit('SET_TOKEN', data.accessToken)
        commit('SET_REFRESH_TOKEN', data.refreshToken)
        setToken(data.accessToken)
        localStorage.setItem("refreshToken",data.refreshToken)
        localStorage.setItem("acount",data.acount)
        localStorage.setItem("userId",data.userId)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      removeToken()
      resolve()
    })
  },
}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}
